import React from 'react';
import { useFilter, SORT_OPTIONS } from '../FilterContext';
import './index.css';

const SearchIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#808080"
    strokeWidth="2"
  >
    <circle cx="11" cy="11" r="7" />
    <path d="m20 20-3.5-3.5" />
  </svg>
);

const FilterBar: React.FC = () => {
  const { query, setQuery, sort, setSort } = useFilter();

  return (
    <div className="filter-bar">
      <div className="filter-bar-search">
        <SearchIcon />
        <input
          type="text"
          placeholder="Search pair, quote or exchange..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        {query && (
          <button className="filter-bar-clear" onClick={() => setQuery('')}>
            ×
          </button>
        )}
      </div>

      <span className="filter-bar-sort-label">Sort by</span>

      <div className="pill-toggle">
        {SORT_OPTIONS.map((opt) => (
          <button
            key={opt}
            className={`pill-toggle-btn${
              sort === opt ? ' pill-toggle-btn--active' : ''
            }`}
            onClick={() => setSort(opt)}
          >
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterBar;
